/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService, AuthBaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { XFoundHttpClient } from '@/core/components/authentication/http/abstractions/xfound.httpclient';

import { UserDisplayModel as AceXFoundPortalCoreCaqModelsUserDisplayModel } from '../models/ace/xFound/Portal/Core/CAQ/Models/user-display-model';

@Injectable({
providedIn: 'root',
})

export class UserService extends BaseService {
constructor(
config: ApiConfiguration,
http: HttpClient,
authHttp: XFoundHttpClient
) {
super(config, http, authHttp);
}

  /**
   * Path part for operation apiUserGet
   */
  static readonly ApiUserGetPath = '/api/User';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiUserGet$Response(params?: {
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqModelsUserDisplayModel>> {

    const rb = new RequestBuilder(this.rootUrl, UserService.ApiUserGetPath, 'get');
    if (params) {
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqModelsUserDisplayModel>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiUserGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiUserGet(params?: {
  }): Observable<AceXFoundPortalCoreCaqModelsUserDisplayModel> {

    return this.apiUserGet$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqModelsUserDisplayModel>) => r.body as AceXFoundPortalCoreCaqModelsUserDisplayModel)
    );
  }

  /**
   * Path part for operation apiUserInstitutionGet
   */
  static readonly ApiUserInstitutionGetPath = '/api/User/Institution';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserInstitutionGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiUserInstitutionGet$Response(params?: {
  }): Observable<StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsUserDisplayModel>>> {

    const rb = new RequestBuilder(this.rootUrl, UserService.ApiUserInstitutionGetPath, 'get');
    if (params) {
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsUserDisplayModel>>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiUserInstitutionGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiUserInstitutionGet(params?: {
  }): Observable<Array<AceXFoundPortalCoreCaqModelsUserDisplayModel>> {

    return this.apiUserInstitutionGet$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsUserDisplayModel>>) => r.body as Array<AceXFoundPortalCoreCaqModelsUserDisplayModel>)
    );
  }

}